import { StrapiVideo } from "~/shared-types";

export const getVideoUrl = (video: StrapiVideo) => {
  // istanbul ignore next
  return process.env.NODE_ENV === "development" &&
    video.attributes.url[0] === "/"
    ? process.env.NEXT_PUBLIC_STRAPI_BASE_URL + video.attributes.url
    : video.attributes.url;
};
